'use client';

import RelatedGrid from '@repo/ui/src/components/RelatedGrid';
import type { RelatedGridProps } from '@repo/ui/src/components/RelatedGrid';
import ProductCard from '@repo/ui/src/components/Cards/ProductCard';

import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

export type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface MeaterRelatedGridProps extends Pick<RelatedGridProps, 'toutContent' | 'backgroundImage'> {
  _data?: Array<MeaterProduct>;
}

export default function MeaterRelatedGrid({
  toutContent,
  backgroundImage,
  _data = [],
}: MeaterRelatedGridProps) {
  const fullProducts: Array<MeaterProduct> = _data && Array.isArray(_data) ? _data : [];

  if (!fullProducts.length) {
    return null;
  }

  return (
    <RelatedGrid toutContent={toutContent} backgroundImage={backgroundImage}>
      {fullProducts?.slice(0, 6).map((productData, index) => (
        <li
          key={index}
          className="[&:nth-child(n+5)]:hidden lg:[&:nth-child(n+5)]:block border border-warm-200 bg-white"
        >
          <ProductCard
            product={productData}
            image={productData.previewImage}
          />
        </li>
      ))}
    </RelatedGrid>
  );
}
